module.exports = __webpack_public_path__ + "static/media/Transport-Logo.ac9ca289.png";